<script>
import app from 'app';
import wtMakeNewStoryboard from 'components/modals/types/wtMakeNewStoryboard.component.vue';
import wtMakeNewWochit from 'components/modals/types/wtMakeNewWochit.component.vue';

export default {
  methods: {
    openMakeNewWochit() {
      if (this.isVideoTemplate) {
        this.mixinShowViewInModal({
          type: 'small',
          component: wtMakeNewStoryboard,
        });
      } else {
        this.mixinShowViewInModal({
          type: 'custom scrollable',
          component: wtMakeNewWochit,
          componentPropsData: {
            story: this.video,
            page: 'producing',
          },
        });
      }
    },

    goToHome() {
      app.state.enableNavigation();
      app.navigateToDashboard();
    },
  },

  computed: {
    isVideoTemplate() {
      return !!this.video.template;
    },

    isUserCanCreateStories() {
      return app.rootStore.getters.isUserCanCreateStories;
    },

    makeNewWochitTitle() {
      if (this.isVideoTemplate) {
        return app.culture.get('generic.MAKE_NEW_STORYBOARD');
      } else {
        return app.culture.get('generic.MAKE_NEW_WOCHIT');
      }
    },
  },
};
</script>
